import React from "react";
import { Modal, Image, Grid, Container, Transition } from "semantic-ui-react";
import tvImage from "../../../semantic/dist/themes/fibrestream/assets/images/tv-dark.png";
//import vmediaImage from "../../../semantic/dist/themes/fibrestream/assets/images/vmedia.png";
import menuBtnClose from "../../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";

const TvModal = props => {
  const { open, closeModal, visible } = props;

  return (
    <Transition visible={visible} animation="slide up" duration={500}>
      <Modal
        open={open}
        onClose={closeModal}
        style={{ boxShadow: "none", height: "100vh" }}
        className="vertical fullscreen modal__map modal__tv centered grid scrolling"
      >
        <Modal.Content scrolling className="scrolling ui centered grid">
          <div className="ui display-1 text-black centered grid modal__title my-0">
            TV
            </div>
          <h3 className="ui itc-std-md normal text-black centered grid modal__desc f-size--24 mx-auto">
            Available to all FibreStream Internet subscribers.
            Visit one of our partners below for more details.
            </h3>
          <Container className="px-0">
            <Grid className="my-0" columns='equal' reversed='mobile vertically tablet vertically'>
              <Grid.Row className="stackable stackable-400" centered columns={3}>
                <Grid.Column className="no-decoration">
                  <Grid verticalAlign='middle' stretched className="ui mx-auto my-0 list-item centered text-prime text-2">
                    {/*   <Grid.Column className="media__left" computer={4} tablet={3} mobile={4} verticalAlign='middle' stretched>
                      <div className="logo-cell">
                        <Image src={vmediaImage} verticalAlign='middle' />
                      </div>
                    </Grid.Column>
                    <Grid.Column className="media__right" computer={12} tablet={13} mobile={12}  textAlign='left' stretched>
                      <p className="text-black mb-0 text-1">
                        VMedia TV Services
                      </p>
                      <p className="text-grey8 text-2">Temporarily Unavailable</p>
                    </Grid.Column> */}
                    <Grid.Column className="text-center">
                      We are working to bring you more TV options. Check back again soon.
                   </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
          <Image src={tvImage} centered className="img-width" />
        </Modal.Content>
        <Modal.Actions className="ui grid centered border-0">
          <button className="ui button deny close" onClick={closeModal}>
            <span className="times text-prime"><Image src={menuBtnClose} verticalAlign='middle' /></span> <span className="text-white close__text">Close</span>
          </button>
        </Modal.Actions>
      </Modal>
    </Transition>
  )
};

export default TvModal;


// WEBPACK FOOTER //
// ./src/components/header/modals/TvModal.js